import { render, staticRenderFns } from "./BsAlert.vue?vue&type=template&id=6857e6a3&"
import script from "./BsAlert.vue?vue&type=script&lang=js&"
export * from "./BsAlert.vue?vue&type=script&lang=js&"
import style0 from "./BsAlert.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports